<template>
  <div>
    <b-modal
      id="review-list-popup"
      title="レビューリスト"
      size="lg"
      ref="reviewListPopup"
      @hide="onModalHide"
      centered
    >
      <template #modal-header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h5 class="mb-0" style="font-weight: bold;">
            格納するリストを選択してください
          </h5>
          <router-link :to="`/setting/review-list`" style="font-size: 18px; color: #787878;">
            リスト詳細・編集 ＞
          </router-link>
        </div>
      </template>
      <div
        class="table-container"
        style="background-color: #ffffff !important;"
      >
        <table class="table" v-show="!loading">
          <thead>
            <tr>
              <th style="width:300px">リスト名</th>
              <th style="width:500px">閲覧権限</th>
              <th style="width:190px">選択</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="reviewList in getReviewLists" :key="reviewList._id">
              <td style="text-align: left; color:rgb(3, 106, 201)">
                {{ reviewList.title }}
              </td>
              <!-- <td><router-link :to="`test`">{{ reviewList.title }}</router-link></td> -->
              <td style="text-align: left;">
                <p
                  v-for="client_users in reviewList.client_users"
                  :key="client_users._id"
                >
                  {{ client_users.full_name }}
                </p>
              </td>
              <td style="text-align: center;">
                <input
                  type="radio"
                  :name="'review-list-select'"
                  class="form-check-input"
                  :checked="selectedReviewListId === reviewList._id"
                  @click="handleRadioClick(reviewList._id, $event)"
                  style="margin-left: -11px !important;"
                />
              </td>
            </tr>
            <tr v-if="!getReviewLists.length">
              <td colspan="100%" class="text-center">
                リスト名が見つかりません
              </td>
            </tr>
          </tbody>
        </table>
        <Loader v-show="loading" />
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100" v-show="!loading">
          <button
            type="button"
            class="btn btn-secondary font-weight-bold review-list-button"
            @click="cancelSelection"
          >
            キャンセル
          </button>
          <button
            type="button"
            class="btn btn-primary custom-primary-btn ml-3 review-list-button"
            :disabled="!selectedReviewListId"
            @click="assignToJudgementList(selectedReviewListId)"
          >
            リストに振分け
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReviewListRow from '@/components/dashboard/reviewList/ReviewListRow.vue';
import Loader from '@/components/utils/Loader.vue';
import ApiService from '@/service/apiService';
import Api from '@/config/api';
import { mapMutations } from 'vuex';
export default {
  name: 'ReviewListPopup',
  components: { ReviewListRow, Loader },
  props: {
    applicant: {
      type: Object,
      required: false,
    },
    showReviewListModal: {
      type: Boolean,
      default: false,
    },
    isBulkOperation: {
      type: Boolean,
      default: false,
      required: false,
    },
    jobseekerIds: {
      type: Array,
      required: false,
    },
    fromPopup: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.showReviewListModal,
      loading: false,
      selectedReviewListId: null,
    };
  },
  computed: {
    ...mapGetters({
      getReviewLists: 'getReviewLists',
    }),
  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterReviewList: 'mutateApplicantsAfterReviewList',
      mutateApplicantsAfterMultipleReviewList:
        'mutateApplicantsAfterMultipleReviewList',
      mutateApplicantsAfterStatus: 'mutateApplicantsAfterStatus',
      removeApplicantFromList: 'removeApplicantFromList',
      removeApplicantFromTempList: 'removeApplicantFromTempList',
      setReloadApplicants: 'setReloadApplicants',
      setCheckAll: 'setCheckAll',
      setJobseekerIds: 'setJobseekerIds',
    }),
    async assignToJudgementList(reviewListId) {
      if (this.isBulkOperation) {
        await this.assignMultipleUsersToReviewList(reviewListId);
      } else {
        await this.assignToReviewList(reviewListId);
      }
    },
    assignToReviewList(reviewListId) {
      ApiService.put(Api.endpoints.ASSIGN_TO_REVIEW_LIST(this.applicant.id), {
        list: reviewListId,
      })
        .then(({ data }) => {
          this.mutateApplicantsAfterReviewList({
            applicant: data.data,
            fromPopup: this.fromPopup,
          });
          const mappedStatus =
            data.data.status === '確認中' ? '確認依頼中' : data.data.status;
          this.$emit('statusChanged', mappedStatus);
          this.mutateApplicantsAfterStatus(data.data);
          if (this.fromPopup) {
            this.removeApplicantFromTempList(data.data);
          } else {
            this.removeApplicantFromList(data.data);
          }
          this.$emit('hideModal');
          if (!this.fromPopup) {
            this.setReloadApplicants(true);
          }
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.loading = false;
          this.$emit('hideModal');
        });
    },
    assignMultipleUsersToReviewList(reviewListId) {
      this.errors = [];
      if (this.jobseekerIds.length == 0) {
        this.errors.push('登録者が選択されていません');
      } else {
        this.loading = true;
        // let list = this.getReviewListModel
        // if(!this.getReviewListModel || this.getReviewListModel.length === 0){
        //   list = null;
        // }
        ApiService.put(Api.endpoints.MULTIPLE_REVIEW_LIST, {
          jobseekerIDs: this.jobseekerIds,
          list: reviewListId,
        })
          .then(({ data }) => {
            this.mutateApplicantsAfterMultipleReviewList(data.data);
            this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
            this.$emit('hideModal');
            this.setReloadApplicants(true);
            // this.mutateApplicantsAfterMultipleStatus(data.data);
          })
          .catch((error) => console.log(error))
          .then(() => {
            this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
          });
      }
    },
    onModalHide() {
      this.$emit('hideModal');
    },
    cancelSelection() {
      this.selectedReviewListId = null;
      this.$emit('hideModal');
    },
    handleRadioClick(id, event) {
      if (this.selectedReviewListId === id) {
        event.target.checked = false;
        this.selectedReviewListId = null;
      } else {
        this.selectedReviewListId = id;
      }
    },
  },
  watch: {
    showReviewListModal(value) {
      this.showModal = value;
    },
    showModal(value) {
      if (value) {
        return this.$refs.reviewListPopup.show();
      }
      return this.$refs.reviewListPopup.hide();
    },
  },
};
</script>

<style scoped>
.table-container {
  height: calc(100vh - 230px); /* Adjust based on your layout needs */
  overflow-y: auto;
  position: relative;
}

input[type="radio"] {
  width: 20px;
  height: 20px;
}

p {
  margin-bottom: 2px !important;
}

>>> .modal-body {
  padding: 0;
}
>>> .modal-header {
  border-bottom: none;
  background-color: #ffffff !important;
}

table th {
  text-align: center;
  border-top: none !important;
  border-bottom: 1px solid #787878 !important;
}
table td {
  border-bottom: 1px solid #787878;
  padding: 5px;
}
>>> .modal-header {
  border-bottom: none;
  padding: 20px;
}
>>> .modal-footer {
  background-color: #ffffff !important;
  border-top: none !important;
}
>>> .modal-footer a {
  font-size: 18px;
  color: #787878;
}

.review-list-button {
  min-width: 120px !important;
  padding: 5px 10px !important;
  font-size: 14px !important;
}

.custom-primary-btn {
  background-color: #B7D2F2 !important;
  border-color: #B7D2F2 !important;
  border-radius: 4px !important;
  color: #000000 !important;
  font-weight: bold !important;
}

.custom-primary-btn:hover {
  background-color: #9fc4ed !important;
  border-color: #9fc4ed !important;
}

</style>
